import React from 'react';
import { Link } from 'react-router-dom';
import { formatImpactScore } from '../../utils/injuryReportHeuristics';
import InjuryReportInsightChips from './InjuryReportInsightChips';
import InjuryReportPlayerIdentity from './InjuryReportPlayerIdentity';
import InjuryReportStatusPill from './InjuryReportStatusPill';
import {
	getTeamDisplayName,
	injuryReportPanelClassName,
	injuryReportRowHoverClassName,
	injuryReportStickyPlayerCellClassName,
	injuryReportTableHeadBgClassName,
	injuryReportTableHeadClassName,
	injuryReportTableHeadRowClassName
} from './injuryReportStyles';

function ImpactBadge({ score }) {
	const value = formatImpactScore(score);
	const tier =
		typeof score === 'number' && score >= 100
			? 'high'
			: typeof score === 'number' && score >= 75
				? 'mid'
				: 'low';

	const tierClass = {
		high: 'bg-blue-600 text-white',
		mid: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:bg-opacity-50 dark:text-blue-200',
		low: 'bg-gray-100 text-gray-700 dark:bg-dark-border dark:text-dark-text'
	}[tier];

	return (
		<span
			className={`inline-flex min-w-10 items-center justify-center rounded-lg px-2 py-1 text-sm font-bold ${tierClass}`}
		>
			{value}
		</span>
	);
}

export default function InjuryReportTable({ players }) {
	return (
		<div className={`hidden lg:block overflow-hidden ${injuryReportPanelClassName}`}>
			<div className="overflow-x-auto">
				<table className="w-full border-collapse" style={{ minWidth: '56rem' }}>
					<thead>
						<tr className={injuryReportTableHeadRowClassName}>
							<th
								className={`${injuryReportTableHeadClassName} ${injuryReportTableHeadBgClassName} px-3 py-3 text-center w-20`}
							>
								Pos Rank
							</th>
							<th
								className={`${injuryReportTableHeadClassName} ${injuryReportTableHeadBgClassName} px-5 py-3 text-left w-72 sticky left-0 z-10`}
							>
								Player
							</th>
							<th
								className={`${injuryReportTableHeadClassName} ${injuryReportTableHeadBgClassName} px-4 py-3 text-left`}
							>
								Team
							</th>
							<th
								className={`${injuryReportTableHeadClassName} ${injuryReportTableHeadBgClassName} px-4 py-3 text-left`}
								style={{ minWidth: '8.75rem' }}
							>
								Status
							</th>
							<th
								className={`${injuryReportTableHeadClassName} ${injuryReportTableHeadBgClassName} px-3 py-3 text-center w-20`}
							>
								Impact
							</th>
							<th
								className={`${injuryReportTableHeadClassName} ${injuryReportTableHeadBgClassName} px-4 py-3 text-left`}
							>
								Signals
							</th>
						</tr>
					</thead>
					<tbody>
						{players.map((row) => (
							<tr key={`${row.position}-${row.id}`} className={injuryReportRowHoverClassName}>
								<td className="px-3 py-3 text-center text-sm font-medium text-gray-800 dark:text-dark-text tabular-nums">
									{row.fantasy_fitness_grade_position_rank || '—'}
								</td>
								<td
									className={`px-5 py-3 w-72 sticky left-0 z-10 ${injuryReportStickyPlayerCellClassName}`}
								>
									<InjuryReportPlayerIdentity player={row} />
								</td>
								<td className="px-4 py-3 text-sm">
									{row.team && row.team.id ? (
										<Link
											to={`/teams/${row.team.id}`}
											className="text-blue-500 hover:underline font-medium"
										>
											{getTeamDisplayName(row.team)}
										</Link>
									) : (
										<span className="text-gray-600 dark:text-gray-300">Free Agent</span>
									)}
								</td>
								<td className="px-4 py-3">
									<InjuryReportStatusPill
										status={row.status}
										injuryDescription={row.injury_description}
									/>
								</td>
								<td className="px-3 py-3 text-center">
									<ImpactBadge score={row.impact_score} />
								</td>
								<td className="px-4 py-3">
									<InjuryReportInsightChips player={row} />
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
}
